<template>
  <div
    :class="'awards_item ' + code">
    <span
      v-text="name"
    />
    <span
      v-if="icon"
      class="awards_crown_icon">
        <svg-inline tag="span">
          <icon :icon="icon" />
        </svg-inline>
      </span>
  </div>
</template>

<script>
import SvgInline from "@/components/ui-kit/svg-inline/index.vue";
import Icon from "@/components/icons/index.vue";

export default {
  components: {
    SvgInline,
    Icon
  },
  inheritAttrs: false,
  props: {
    name: {
      type: String,
    },
    code: {
      type: String,
    },
    icon: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.awards {
  &_item {
    display: flex;
    padding: 5px 5px 6px;
    color: #121212;
    margin: 0 8px;
    background: linear-gradient(107.46deg, #FCEF7F 17.49%, #FFC785 95.86%);
    border-radius: 4px;
    height: 18px;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    font-size: 12px;
    white-space: nowrap;

    &.best_expert {
      margin: 2px 0;
      font-size: 11px;
    }
  }
}

.awards_crown_icon {
  margin-left: 5px;

  .svg-inline {
    width: 16px;
    height: 12px;
  }
}
</style>
